import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TileButton = ({ link, text }: any) => (
   <button
      type="button"
      onClick={() => {
         window.location.href = link;
      }}
      className="mt-4 inline-flex h-9 min-w-[150px] cursor-pointer items-center justify-center self-end rounded-lg bg-brand-500 px-4 font-semibold text-white transition-colors after:absolute after:inset-0 hover:bg-brand-600 sm:mt-6 sm:min-w-full"
   >
      {text}
   </button>
);

const OptionCard = ({ images, links, option }: any) => (
   <div className="relative flex flex-col place-items-center overflow-hidden rounded-lg border border-gray-300 bg-white p-3 text-gray-800 md:px-5 md:pb-6 md:pt-0">
      <img
         width="250"
         height="160"
         className="hidden h-[215px] min-w-[calc(100%+40px)] object-cover md:block"
         srcSet={`${images[option.imageIndex]['srcset']}_320.jpeg 320w, ${
            images[option.imageIndex]['srcset']
         }_500.jpeg 500w`}
         src={images[option.imageIndex]['image']}
         alt={option.altText}
      />
      <div className="flex flex-1 flex-row md:flex-col lg:min-h-[164px]">
         <div className="mt-0 mr-3 mb-3 ml-auto flex h-14 w-14 flex-none items-center justify-center overflow-hidden rounded-md border border-brand-200 bg-brand-100 text-brand-500 md:mx-auto md:mt-[-28px] md:mb-6">
            <FontAwesomeIcon icon={option.icon} size="lg" />
         </div>
         <div className="flex h-full grow flex-col text-start md:text-center">
            <h3 className="m-0 text-xl font-medium text-gray-800">{option.title}</h3>
            <p className="mx-auto my-0 grow pt-1.5 text-gray-600 md:pt-2">{option.description}</p>
         </div>
      </div>
      <TileButton link={links[option.linkKey]} text={option.buttonText} />
   </div>
);

export default OptionCard;
